// // components/address-sheet.tsx
// 'use client';

// import { useEffect, useLayoutEffect, useState, useTransition } from 'react';
// import { Button } from '../ui/button';
// //@ts-expect-error:missing types
// import { useGoogleMaps } from '@jahez-ui/google-maps';
// import { ChevronRight, MapPin, X } from 'lucide-react';
// import {
//   Drawer,
//   DrawerClose,
//   DrawerContent,
//   DrawerFooter,
//   DrawerHeader,
//   DrawerTitle,
//   DrawerTrigger,
// } from '../ui/drawer';
// import { useTranslations } from 'next-intl';
// import { useLocationStore } from '@/src/lib/state-stores/locationStore'; // Use corrected hook
// import {
//   setLocationDetailsInCookies,
//   getLocationDetailsFromCookies,
// } from '@/src/lib/actions/getCookies';
// import { AddressTypeStrEnum } from '@/src/types/address';
// import { CMSSectionsAPi } from '@/src/app/[locale]/(cms)/CMSComponents/services/getCMS.service';
// import { CMSData } from '@/src/app/[locale]/(cms)/CMSComponents/services/types';
// import { useRouter } from '@/src/i18n/navigation';

// type AddressDialogProps = {
//   defaultLatitude?: string;
//   defaultLongitude?: string;
//   lang: 'ar' | 'en';
// };

// const AddressContent: React.FC<
//   AddressDialogProps & { openMap?: boolean; setOpenMap: (inp: boolean) => void }
// > = ({ setOpenMap, lang }) => {
//   const t = useTranslations('address');
//   const { locationDetails, setLocationDetails } = useLocationStore();
//   const [isPending, setTransition] = useTransition();
//   const [cmsData, setCmsData] = useState<CMSData[]>([]);

//   const {
//     googleMapComponent,
//     currentMarkerAddress,
//     currentDistrict,
//     currentPostalCode,
//     currentCity,
//     currentCountry,
//     currentRoute,
//   } = useGoogleMaps({
//     googleApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
//     lat: Number(locationDetails?.location.latitude) || 24.7438193,
//     lng: Number(locationDetails?.location.longitude) || 46.7039281,
//     defaults: {
//       zoom: 15,
//       centerPoint: {
//         lat: Number(locationDetails?.location.latitude) || 24.7438193,
//         lng: Number(locationDetails?.location.longitude) || 46.7039281,
//       },
//     },
//     onCoordsChange(latitude: number, longitude: number) {
//       setLocationDetails({
//         location: { latitude, longitude },
//         name: currentDistrict || currentPostalCode || locationDetails?.name || '',
//         type: 3,
//         details: currentMarkerAddress,
//         city: currentCity,
//         country: currentCountry,
//         typeArabicName: AddressTypeStrEnum.Other,
//         typeEnglishName: AddressTypeStrEnum.Other,
//         street: currentRoute,
//         zip_code: currentPostalCode,
//       });
//     },
//     showPin: true,
//     currenLocation: {
//       enabled: true,
//       onLoadLocation(lat: number, lng: number, event: string) {
//         if (!locationDetails?.location.latitude || event === 'current location') {
//           setLocationDetails({
//             location: { latitude: lat, longitude: lng },
//             name: currentDistrict || currentPostalCode || locationDetails?.name || '',
//             type: 3,
//             details: currentMarkerAddress,
//             city: currentCity,
//             country: currentCountry,
//             typeArabicName: AddressTypeStrEnum.Other,
//             typeEnglishName: AddressTypeStrEnum.Other,
//             street: currentRoute,
//             zip_code: currentPostalCode,
//           });
//         }
//       },
//     },
//   });

//   const handleSaveCoordinates = () => {
//     setTransition(async () => {
//       if (locationDetails?.location.latitude && locationDetails?.location.longitude) {
//         const currentCookieLocation = await getLocationDetailsFromCookies();
//         if (
//           currentCookieLocation?.location.latitude === locationDetails.location.latitude &&
//           currentCookieLocation?.location.longitude === locationDetails.location.longitude
//         ) {
//           setOpenMap(false);
//           return;
//         }

//         // Update cookies
//         await setLocationDetailsInCookies(locationDetails);

//         // Fetch updated CMS data
//         try {
//           const newCmsData = await CMSSectionsAPi.getCMSSections();
//           setCmsData(newCmsData);
//           // Dispatch event to notify other components
//           window.dispatchEvent(new CustomEvent('location-updated', { detail: newCmsData }));
//         } catch (error) {}

//         setOpenMap(false);
//       }
//     });
//   };

//   useEffect(() => {
//     const initializeAddress = async () => {
//       const cookieLocation = await getLocationDetailsFromCookies();
//       if (cookieLocation?.name) {
//         setLocationDetails(cookieLocation);
//       }
//     };
//     initializeAddress();
//   }, [setLocationDetails]);

//   return (
//     <>
//       <DrawerTrigger asChild>
//         <button
//           className="group flex flex-row items-center space-x-2 outline-hidden rtl:space-x-reverse"
//           onClick={() => setOpenMap(true)}
//           type="button"
//         >
//           <MapPin className="text-primary" size={28} />
//           <div className="flex flex-col items-start">
//             <div className="text-sm text-neutral-800">{t('address')}</div>
//             <div className="text-primary max-w-[100px] truncate text-sm transition-opacity group-hover:opacity-50">
//               {locationDetails?.name ?? t('set-address')}
//             </div>
//           </div>
//           <ChevronRight className="transform self-end rtl:-scale-x-100" />
//         </button>
//       </DrawerTrigger>
//       <DrawerContent className="bg-white">
//         <DrawerHeader>
//           <DrawerTitle className="flex items-center justify-between">
//             <span>{t('set-location')}</span>
//             <DrawerClose onClick={() => setOpenMap(false)}>
//               <X />
//             </DrawerClose>
//           </DrawerTitle>
//         </DrawerHeader>
//         <div className="map-parent z-50 mb-4 block h-[60dvh] w-full">{googleMapComponent}</div>
//         <DrawerFooter>
//           <Button loading={!!isPending} rounded="full" onClick={handleSaveCoordinates}>
//             {t('save-address')}
//           </Button>
//           <DrawerClose asChild>
//             <Button rounded="full" variant="outline" onClick={() => setOpenMap(false)}>
//               {t('cancel')}
//             </Button>
//           </DrawerClose>
//         </DrawerFooter>
//       </DrawerContent>
//     </>
//   );
// };

// export const AddressSheet: React.FC<AddressDialogProps> = (props) => {
//   const [openMap, setOpenMap] = useState(false);
//   const { setLocationDetails } = useLocationStore();

//   const handleClose = async () => {
//     const cookieLocation = await getLocationDetailsFromCookies();
//     if (cookieLocation) {
//       setLocationDetails(cookieLocation);
//     }
//     setOpenMap(false);
//   };

//   return (
//     <Drawer open={openMap} onOpenChange={setOpenMap} onClose={handleClose} dismissible={false}>
//       <AddressContent setOpenMap={setOpenMap} openMap={openMap} key={`map-${openMap}`} {...props} />
//     </Drawer>
//   );
// };

'use client';

import { useEffect, useState, useTransition, useRef } from 'react';
import { Button } from '../ui/button';
//@ts-expect-error:missing types
import { useGoogleMaps } from '@jahez-ui/google-maps';
import { ChevronRight, MapPin, X } from 'lucide-react';
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '../ui/drawer';
import { useTranslations } from 'next-intl';
import { useLocationStore } from '@/src/lib/state-stores/locationStore';
import {
  setLocationDetailsInCookies,
  getLocationDetailsFromCookies,
} from '@/src/lib/actions/getCookies';
import { AddressTypeStrEnum } from '@/src/types/address';
import { refreshServerData, updateCountryId } from '@/src/lib/actions';
import { useCountryStore } from '@/src/lib/state-stores/currencyStore';
import { useRouter } from '@/src/i18n/navigation';

type AddressDialogProps = {
  defaultLatitude?: string;
  defaultLongitude?: string;
  lang: 'ar' | 'en';
};

const AddressContent: React.FC<
  AddressDialogProps & { openMap?: boolean; setOpenMap: (inp: boolean) => void }
> = ({ setOpenMap }) => {
  const t = useTranslations('address');
  const { locationDetails, setLocationDetails } = useLocationStore();
  const { setCountryId } = useCountryStore();
  const [isPending, setTransition] = useTransition();
  const router = useRouter();

  // State محلية ومؤقتة لحركة الخريطة والدبوس (تمنع الـ Infinity Loop تماماً)
  const [tempCoords, setTempCoords] = useState({
    latitude: Number(locationDetails?.location.latitude) || 24.7438193,
    longitude: Number(locationDetails?.location.longitude) || 46.7039281,
  });

  const {
    googleMapComponent,
    currentMarkerAddress,
    currentDistrict,
    currentPostalCode,
    currentCity,
    currentCountry,
    currentRoute,
  } = useGoogleMaps({
    googleApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
    lat: tempCoords.latitude,
    lng: tempCoords.longitude,
    defaults: {
      zoom: 15,
      centerPoint: {
        lat: tempCoords.latitude,
        lng: tempCoords.longitude,
      },
    },
    onCoordsChange(latitude: number, longitude: number) {
      // تحديث الإحداثيات محلياً فقط أثناء سحب المتصفح للدبوس
      setTempCoords({ latitude, longitude });
    },
    showPin: true,
    currenLocation: {
      enabled: true,
      onLoadLocation(lat: number, lng: number, event: string) {
        if (!locationDetails?.location.latitude || event === 'current location') {
          setTempCoords({ latitude: lat, longitude: lng });
        }
      },
    },
  });

  // تجميع كائن العنوان بشكل حي ومباشر بناءً على إحداثيات الخريطة الحالية
  const getCompiledAddressObject = () => {
    return {
      location: { latitude: tempCoords.latitude, longitude: tempCoords.longitude },
      name: currentDistrict || currentPostalCode || locationDetails?.name || '',
      type: 3,
      details: currentMarkerAddress || '',
      city: currentCity || '',
      country: currentCountry || '',
      typeArabicName: AddressTypeStrEnum.Other,
      typeEnglishName: AddressTypeStrEnum.Other,
      street: currentRoute || '',
      zip_code: currentPostalCode || '',
    };
  };

  const handleSaveCoordinates = () => {
    setTransition(async () => {
      const finalAddress = getCompiledAddressObject();

      if (finalAddress.location.latitude && finalAddress.location.longitude) {
        const currentCookieLocation = await getLocationDetailsFromCookies();

        if (
          currentCookieLocation?.location.latitude === finalAddress.location.latitude &&
          currentCookieLocation?.location.longitude === finalAddress.location.longitude
        ) {
          setOpenMap(false);
          return;
        }

        await setLocationDetailsInCookies(finalAddress);
        setLocationDetails(finalAddress);

        const res = await updateCountryId();
        if (res?.success) {
          setCountryId(res.countryId as any);
        }

        setOpenMap(false);
      }
    });
  };

  // جلب اللوكيشن من الكوكيز عند أول فتح للموقع فقط (منع التضارب)
  const isFetched = useRef(false);
  useEffect(() => {
    if (isFetched.current) return;
    const initializeAddress = async () => {
      const cookieLocation = await getLocationDetailsFromCookies();
      if (cookieLocation?.name) {
        setLocationDetails(cookieLocation);
        setTempCoords({
          latitude: Number(cookieLocation.location.latitude),
          longitude: Number(cookieLocation.location.longitude),
        });
      }
      isFetched.current = true;
    };
    initializeAddress();
  }, [setLocationDetails]);

  return (
    <>
      <DrawerTrigger asChild>
        <button
          className="group flex flex-row items-center space-x-2 outline-hidden rtl:space-x-reverse"
          onClick={() => setOpenMap(true)}
          type="button"
          suppressHydrationWarning
        >
          <MapPin className="text-primary" size={28} />
          <div className="flex flex-col items-start">
            <div className="text-sm text-neutral-800">{t('address')}</div>
            <div className="text-primary max-w-25 truncate text-sm transition-opacity group-hover:opacity-50">
              {locationDetails?.name ?? t('set-address')}
            </div>
          </div>
          <ChevronRight className="transform self-end rtl:-scale-x-100" />
        </button>
      </DrawerTrigger>

      <DrawerContent className="bg-white">
        <DrawerHeader>
          <DrawerTitle className="flex items-center justify-between">
            <span>{t('set-location')}</span>
            <DrawerClose onClick={() => setOpenMap(false)}>
              <X />
            </DrawerClose>
          </DrawerTitle>
        </DrawerHeader>

        <div className="map-parent z-50 mb-4 block h-[60dvh] w-full">{googleMapComponent}</div>

        <DrawerFooter>
          <Button loading={!!isPending} rounded="full" onClick={handleSaveCoordinates}>
            {t('save-address')}
          </Button>
          <DrawerClose asChild>
            <Button rounded="full" variant="outline" onClick={() => setOpenMap(false)}>
              {t('cancel')}
            </Button>
          </DrawerClose>
        </DrawerFooter>
      </DrawerContent>
    </>
  );
};

export const AddressSheet: React.FC<AddressDialogProps> = (props) => {
  const [openMap, setOpenMap] = useState(false);
  const { setLocationDetails } = useLocationStore();

  const handleClose = async () => {
    const cookieLocation = await getLocationDetailsFromCookies();
    if (cookieLocation) {
      setLocationDetails(cookieLocation);
    }
    setOpenMap(false);
  };

  return (
    <Drawer open={openMap} onOpenChange={setOpenMap} onClose={handleClose} dismissible={false}>
      {/* الـ key الفريد يضمن إعادة بناء نظيفة للـ View بدون بقايا داتا قديمة */}
      <AddressContent
        setOpenMap={setOpenMap}
        openMap={openMap}
        key={`map-view-${openMap}`}
        {...props}
      />
    </Drawer>
  );
};
